import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { certifications } from "@/mocks/sustainability";

export default function Certifications() {
  const root = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!root.current) return;
    const ctx = gsap.context(() => {
      gsap.from(".cert-card", {
        y: 40,
        opacity: 0,
        duration: 1,
        stagger: 0.1,
        ease: "power3.out",
        scrollTrigger: { trigger: root.current, start: "top 75%" },
      });
    }, root);
    return () => ctx.revert();
  }, []);

  return (
    <section ref={root} className="bg-bone py-24 md:py-36 px-6 md:px-10">
      <div className="max-w-6xl mx-auto">
        <div className="text-center max-w-2xl mx-auto mb-14 md:mb-20">
          <p className="text-[11px] font-mono uppercase tracking-[0.22em] text-ink/50 mb-4">
            ✦ Verified by third parties
          </p>
          <h2 className="font-display text-4xl md:text-6xl text-ink tracking-tightest font-light leading-[0.95]">
            Certifications, <span className="font-display text-rust">not claims.</span>
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-6">
          {certifications.map((cert) => (
            <div
              key={cert.name}
              className="cert-card flex flex-col items-center text-center p-6 md:p-8 rounded-[20px] bg-sand/40 hover:bg-sand/70 transition-colors"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-forest/10 text-forest mb-4">
                <i className="ri-shield-check-line text-xl"></i>
              </div>
              <h4 className="font-display text-lg text-ink tracking-tightest font-medium">
                {cert.name}
              </h4>
              <p className="mt-1 text-xs text-ink/50 font-mono uppercase tracking-[0.15em]">
                {cert.issuer}
              </p>
              <p className="mt-2 text-xs text-ink/40 font-mono">
                Since {cert.year}
              </p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-20 text-center">
          <p className="text-ink/60 text-base md:text-lg max-w-xl mx-auto leading-relaxed">
            Want to dig deeper? We publish our full environmental impact report every quarter, audited independently and available to download.
          </p>
          <div className="mt-8">
            <button className="inline-flex items-center gap-3 bg-forest text-bone px-8 py-4 rounded-full text-sm font-medium tracking-wide uppercase hover:bg-ink transition-colors cursor-pointer whitespace-nowrap">
              Download 2025 report
              <i className="ri-download-line text-base"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}